import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query' // << הוספנו את זה
import './index.css'
import { RootCmp } from './RootCmp'
import { Toaster } from 'react-hot-toast'
import { Provider } from 'react-redux'
import { store } from './store/store'
import { utilService } from './services/util.service'
import { AnalyticsTracker } from './services/AnalyticsTracker'

// יצירת QueryClient
const queryClient = new QueryClient()

createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <Toaster />
          <AnalyticsTracker />
          <RootCmp />
        </QueryClientProvider>
      </Provider>
    </Router>
  </HelmetProvider>
)
